import { render, staticRenderFns } from "./EditRede.vue?vue&type=template&id=35076a1a&"
import script from "./EditRede.vue?vue&type=script&lang=js&"
export * from "./EditRede.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports